export default __webpack_public_path__ + "grd-login-background.jpg";